import { render, staticRenderFns } from "./distributorManagement.vue?vue&type=template&id=da5d6464&"
import script from "./distributorManagement.vue?vue&type=script&lang=js&"
export * from "./distributorManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "distributorManagement.vue"
export default component.exports